import React, { Component } from "react";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import config from "../../config";
import moment from "moment";
import utilityFunctions from "../../store/utilityFunctions";
import LoadingPage from "../Loading/Loading";

Modal.setAppElement("body");

export default class TimeMachine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      msgText: "",
      fromDate: "",
      toDate: "",
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleSubmit = (e) => {
    if (!this.state.fromDate || !this.state.toDate) {
      this.setState({ msgText: "Warning: Date can not be empty" });
      return;
    }
    if (this.state.fromDate > this.state.toDate) {
      this.setState({ msgText: "Warning: From date can not be greater than to date" });
      return;
    }
    this.setState({ loading: true });
    e.preventDefault();
    console.log(this.state.addComment);

    const fromDate = this.state.fromDate ? `from_date=${moment(this.state.fromDate).format("YYYY-MM-DD")}` : "";
    const toDate = this.state.toDate ? `${this.state.fromDate ? "&" : ""}to_date=${moment(this.state.toDate).format("YYYY-MM-DD")}` : "";

    const url = `${config.backendServer}report/export_activity_ticket/?${fromDate}${toDate}`;

    utilityFunctions
      .protectedFetch(url, "GET", null, (res) => {
        return res; // Do everything in the 'then'
      })
      .then((res) => {
        if (res.ok) {
          res.blob().then((res) => {
            const blob = res;
            blob.name = "Time_Machine_" + moment(this.state.toDate).format("YYYY-MM-DD");
            utilityFunctions.downloadFileAutomatically(blob, res.type);
            this.setState({ msgText: "Succes: Time Machine Report successfully created", loading: false });
            setTimeout(() => this.props.handleCloseModal(), 3000);
          });
        }
      })
      .catch((error) => {
        console.log("fail");
        this.setState({ loading: false, msgText: error });
      });
  };

  render() {
    return (
      <div className="card">
        <div className="card-header">Time Machine Report</div>
        <div className={"card-body"}>
          <div className=" d-flex justify-content-center gap-4">
            <div>
              <div>From Date:</div>
              <DatePicker
                id="fromDate"
                className="form-control "
                maxDate={moment().toDate()}
                selected={this.state.fromDate}
                dateFormat="dd/MM/yyyy"
                onChange={(val) =>
                  this.setState({
                    fromDate: val,
                  })
                }
              />
            </div>
            <div>
              <div>To Date:</div>
              <DatePicker
                id="toDate"
                className="form-control"
                maxDate={moment().toDate()}
                selected={this.state.toDate}
                dateFormat="dd/MM/yyyy"
                onChange={(val) =>
                  this.setState({
                    toDate: val,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className={`text-center ${this.state.msgText.includes("Warning") ? "text-danger" : "text-primary"}`}>{this.state.msgText}</div>
        <div className="card-footer  d-flex justify-content-center gap-4">
          <button onClick={this.handleSubmit} className="btn btn-primary btm-sm mr-2">
            Export
          </button>
          <button onClick={() => this.props.handleCloseModal()} className="btn btn-secondary btm-sm">
            Close
          </button>
          {this.state.loading && <LoadingPage small />}
        </div>
      </div>
    );
  }
}
